import { DatabaseSnapshot } from 'angularfire2/database/interfaces';

export class User {
  static readonly PropertyKey = {
    email: 'email',
    firstName: 'first_name',
    lastName: 'last_name',
    company: 'company',
    position: 'position',
    birthday: 'birthday',
    gender: 'gender',
    contactNumber: 'contact_number',
    facebookId:  'facebook_id',
    twitterScreenName: 'twitter_screen_name',
    instagramUsername: 'instagram_username',
    linkedinId: 'linkedin_id',
    roleIsThinkBIT: 'role_is_thinkbit',
    roleIsCompany: 'role_is_company',
    roleIsParticipant: 'role_is_participant',
    roleIsUsher: 'role_is_usher'
  };

  // Set on demand
  public profileImageURL$?: Promise<URL | null>;

  constructor(
    public id: string,
    public email: string | null,
    public firstName: string | null,
    public lastName: string | null,
    public company: string | null,
    public position: string | null,
    public birthday: string | null,
    public gender: string | null,
    public contactNumber: string | null,
    public facebookId: string | null,
    public twitterScreenName: string | null,
    public instagramUsername: string | null,
    public linkedinId: string | null,
    public roleIsThinkBIT: boolean | null,
    public roleIsCompany: boolean | null,
    public roleIsParticipant: boolean | null,
    public roleIsUsher: boolean | null) { }

  static fromDatabaseSnapshot(snapshot: DatabaseSnapshot): User | null {
    const id = snapshot.key;

    if (!snapshot.exists() || !id) {
      return null;
    }

    const email = snapshot.child(this.PropertyKey.email).val();
    const firstName = snapshot.child(this.PropertyKey.firstName).val();
    const lastName = snapshot.child(this.PropertyKey.lastName).val();
    const company = snapshot.child(this.PropertyKey.company).val();
    const position = snapshot.child(this.PropertyKey.position).val();
    const birthday = snapshot.child(this.PropertyKey.birthday).val();
    const gender = snapshot.child(this.PropertyKey.gender).val();
    const contactNumber = snapshot.child(this.PropertyKey.contactNumber).val();
    const facebookId = snapshot.child(this.PropertyKey.facebookId).val();
    const twitterScreenName = snapshot.child(this.PropertyKey.twitterScreenName).val();
    const instagramUsername = snapshot.child(this.PropertyKey.instagramUsername).val();
    const linkedinId = snapshot.child(this.PropertyKey.linkedinId).val();
    const roleIsThinkBIT = snapshot.child(this.PropertyKey.roleIsThinkBIT).val();
    const roleIsCompany = snapshot.child(this.PropertyKey.roleIsCompany).val();
    const roleIsParticipant = snapshot.child(this.PropertyKey.roleIsParticipant).val();
    const roleIsUsher = snapshot.child(this.PropertyKey.roleIsUsher).val();

    return new this(id, email, firstName, lastName, company, position, birthday, gender, contactNumber, facebookId,
      twitterScreenName, instagramUsername, linkedinId, roleIsThinkBIT, roleIsCompany, roleIsParticipant, roleIsUsher);
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/models/user.ts